import React from "react";
import ProtectedRoute from "routes/ProtectedRoute";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

export const studioRoutes = [
  {
    path: "studio",
    loader: protectedRouteLoader,
    children: [
      {
        path: ":playlistId/renderer-test",
        lazy: async () => {
          const mod = await import("views/Admin/studio/studio-renderer-test");
          const StudioRendererTest = mod.default;

          return {
            Component: () => (
              <ProtectedRoute>
                <StudioRendererTest />
              </ProtectedRoute>
            ),
          };
        },
      },
      {
        path: ":playlistId/:legacyEventId/renderer-test",
        lazy: async () => {
          const mod = await import("views/Admin/studio/studio-renderer-test");
          const StudioRendererTest = mod.default;

          return {
            Component: () => (
              <ProtectedRoute>
                <StudioRendererTest />
              </ProtectedRoute>
            ),
          };
        },
      },
      {
        path: ":playlistId",
        lazy: async () => {
          const mod = await import("views/Admin/studio/studio-edit");
          const StudioEdit = mod.StudioEdit;

          return {
            Component: () => (
              <ProtectedRoute>
                <StudioEdit />
              </ProtectedRoute>
            ),
          };
        },
      },
      {
        path: ":playlistId/:legacyEventId",
        lazy: async () => {
          const mod = await import("views/Admin/studio/studio-edit");
          const StudioEdit = mod.StudioEdit;

          return {
            Component: () => (
              <ProtectedRoute>
                <StudioEdit />
              </ProtectedRoute>
            ),
          };
        },
      },
    ],
  },
];
